import { render, staticRenderFns } from "./SwitchCameraButton.vue?vue&type=template&id=066a5e9a&scoped=true&"
import script from "./SwitchCameraButton.vue?vue&type=script&lang=js&"
export * from "./SwitchCameraButton.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCameraButton.vue?vue&type=style&index=0&id=066a5e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a5e9a",
  null
  
)

export default component.exports